import { gql } from "@apollo/client";

export const CreateInstalledBaseNodeSubscription = gql`
    mutation CreateInstalledBaseNodeSubscription ($installedBaseNodeId: ID!, $input: InstalledBaseNodeSubscriptionInput!) {
        createInstalledBaseNodeSubscription(installedBaseNodeId: $installedBaseNodeId, input: $input) {
            id
            inApp
            mail
            push
            iotAlert
            iotAlertSeverity
            maintenanceDue
            maintenanceSeverity
            maintenanceType
            installedBaseNode {
                id
                title
            }
        }
    }
`;
